import { DOCS, RESOURCES, COMMUNITY, GETSTARTED } from "./constants";
import icons from "./icons";
import { DEV_CENTER_AUTH0_SIGNUP_URL } from "@hub/services/content/data/content-values";

const dictionary = {
  sections: [
    {
      id: DOCS,
      text: "Docs",
    },
    {
      id: RESOURCES,
      text: "Resources",
    },
    {
      id: COMMUNITY,
      text: "Community",
    },
    {
      id: GETSTARTED,
      text: "Get Started",
    },
  ],
  buttons: [
    {
      text: "Log in",
      url: "https://auth0.com/api/auth/login?redirectTo=dashboard",
      typeMobile: "tertiary",
      typeDesktop: "tertiary",
    },
    {
      text: "Sign up",
      url: DEV_CENTER_AUTH0_SIGNUP_URL,
      typeMobile: "tertiary",
      typeDesktop: "primary",
    },
    {
      text: "Contact sales",
      url: "https://auth0.com/contact-us",
      typeMobile: "primary",
      typeDesktop: "none",
    },
  ],
  [DOCS]: [
    {
      title: "Documentation",
      links: [
        {
          title: "Quickstarts",
          description:
            "Step-by-step guides to quickly integrate Auth0 into your app.",
          url: "https://auth0.com/docs/quickstarts/",
        },
        {
          title: "Auth0 APIs",
          description: "APIs for developers to consume in their apps.",
          url: "https://auth0.com/docs/api",
        },
        {
          title: "SDK Libraries",
          description: "Integrate and interact easily with Auth0",
          url: "https://auth0.com/docs/libraries",
        },
        {
          title: "Articles",
          description: "Learn what the Auth0 platform has to offer.",
          url: "https://auth0.com/docs/articles",
        },
      ],
    },
  ],
  [RESOURCES]: [
    {
      title: "Resources",
      links: [
        {
          title: "Code Samples",
          description:
            "Experience the identity and security features of Auth0.",
          url: "https://developer.auth0.com/resources/code-samples",
        },
        {
          title: "Guides",
          description:
            "Learn how to integrate Auth0 with different frameworks and languages.",
          url: "https://developer.auth0.com/resources/guides",
        },
        {
          title: "Labs",
          description:
            "Follow engaging exercises to learn how to use Auth0 beyond the basics.",
          url: "https://developer.auth0.com/resources/labs",
        },
        {
          title: "Workshops",
          description:
            "Engaging and interactive sessions to learn how to use Auth0.",
          url: "https://developer.auth0.com/resources/workshops",
        },
        {
          title: "Blog Posts",
          description:
            "Keep up to date with our developer content, created by developers.",
          url: "https://auth0.com/blog/",
        },
        {
          title: "Videos",
          description:
            "Our YouTube channel dedicated to teach security and identity concepts.",
          url: "https://youtube.com/auth0",
        },
        {
          title: "Templates",
          description:
            "Boost your authentication workflows with pre-built solutions.",
          url: "https://developer.auth0.com/resources/templates",
        },
        {
          title: "Zero Index Newsletter",
          description:
            "Our monthly digest of relevant and curated developer content.",
          url: "https://developers.auth0.com/newsletter",
        },
      ],
    },
    {
      title: "Developer tools",
      links: [
        {
          title: "JWT Tool",
          description: "Decode, verify, and debug JWTs.",
          url: "https://jwt.io/",
          icon: icons.JWT,
        },
        {
          title: "Webauthn Playground",
          description: "Interactive tutorial and WebAuthn config debugger.",
          url: "https://webauthn.me",
          icon: icons.WebAuthn,
        },
        {
          title: "Passkeys Playground",
          description: "Learn how passkeys work using an interactive demo.",
          url: "https://learnpasskeys.io/",
          icon: icons.Passkeys,
        },
        {
          title: "OpenID Connect Playground",
          description: "Learn how OIDC works in this interactive environment.",
          url: "https://openidconnect.net/",
          icon: icons.OpenID,
        },
        {
          title: "SAML Tool",
          description: "Decode, inspect, and verify SAML messages.",
          url: "https://samltool.io/",
          icon: icons.SAML,
        },
      ],
    },
  ],
  [COMMUNITY]: [
    {
      title: "Community",
      links: [
        {
          title: "Forum",
          description:
            "Ask questions, share ideas, and get to know other Auth0 developers.",
          url: "https://community.auth0.com/",
        },
        {
          title: "Events",
          description:
            "Come join the Auth0 team at our virtual events or an event near you.",
          url: "https://developers.auth0.com/events",
        },
        {
          title: "Ambassador Program",
          description:
            "Meet a global team of developers who share their Auth0 knowledge.",
          url: "https://auth0.com/ambassador-program",
        },
        {
          title: "Support",
          description: "Having Trouble? We are here to help you.",
          url: "https://support.auth0.com/",
        },
        {
          title: "Auth0 Apollo Program",
          description:
            "Join amazing developers who have written for the Auth0 Blog.",
          url: "https://auth0.com/apollo-program",
        },
        {
          title: "Auth0 Research Program",
          description:
            "Give feedback towards our product improvements and get rewarded for your participation.",
          url: "https://auth0.com/research-program",
        },
      ],
    },
    {
      // TODO: get this dynamically, still unsure about where will this featured event be coming from
      title: "Featured Event",
      eventName: "Best of DevDay",
      description:
        "This webinar will give you the TL;DR on the most exciting announcements shared at dev_day(24) and Oktane, spotlighting the trending identity topics discussed this year.",
      image:
        "https://cdn.auth0.com/website/develope-center/assets/boo-banner.png",
      url: "https://a0.to/watch-best-of-devday24",
    },
  ],
  [GETSTARTED]: [
    {
      title: "Get Started",
      links: [
        {
          title: "Native/Mobile App",
          description: "Mobile or Desktop app that runs natively on a device",
          icon: icons.Mobile,
          url: "https://developer.auth0.com/resources/get-started/mobile",
        },
        {
          title: "Single-Page App",
          description: "JavaScript web app that runs in the browser",
          icon: icons.SPA,
          url: "https://developer.auth0.com/resources/get-started/spa",
        },
        {
          title: "Regular Web App",
          description: "Traditional web app that runs on the server",
          icon: icons.Webapp,
          url: "https://developer.auth0.com/resources/get-started/web-app",
        },
        {
          title: "Backend/API",
          description: "An API or service protected by Auth0",
          icon: icons.Backend,
          url: "https://developer.auth0.com/resources/get-started/api",
        },
        {
          title: "Cloud App",
          description:
            "An application hosted in the cloud (e.g. Vercel, Netlify)",
          icon: icons.Cloud,
          url: "https://developer.auth0.com/resources/get-started/cloud",
        },
      ],
    },
  ],
};

export default dictionary;
